import {IRoles, RolesResponseType} from "@/entity/user/roles/roles.types";

export default class Roles implements IRoles {
    id: number | null;
    name: string;
    created_at: string;
    updated_at: string;
    constructor(data: RolesResponseType) {
        this.id = data.id;
        this.name = data.name;
        this.created_at = data.created_at;
        this.updated_at = data.updated_at;
    }
}